// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.deactivate.RentalManagerUserPropertyDeactivateWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing,
  RentalManagerUserPropertyDeactivateWebApiHandler_leases,
  RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary,
  RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  DeactivateListingRequestDto,
  DeactivateListingResponseDto,
  GetDeactivateListingTenantsSummaryResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

interface LeasesParams {
  listingAlias: ListingAlias;
  type: string;
  value: boolean;
}
interface TenantsSummaryParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Args {
  postData: DeactivateListingRequestDto;
}

export type RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Options = UseMutationOptions<
  DeactivateListingResponseDto,
  unknown,
  RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Args
>;

export const useRentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Args) =>
      RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyDeactivateWebApiHandler_leases_Args {
  getParams: LeasesParams;
}

export type RentalManagerUserPropertyDeactivateWebApiHandler_leases_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyDeactivateWebApiHandler_leases_Args
>;

/**
 * Save leases survey response. Types: haveSignedLease, uploadSignedLease, haveLeaseAgreement, uploadUnsignedLease, createLease
 * @deprecated
 */
export const useRentalManagerUserPropertyDeactivateWebApiHandler_leases = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyDeactivateWebApiHandler_leases_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDeactivateWebApiHandler_leases_Args) =>
      RentalManagerUserPropertyDeactivateWebApiHandler_leases(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_Options = UseQueryOptions<
  GetDeactivateListingTenantsSummaryResponseDto,
  unknown,
  GetDeactivateListingTenantsSummaryResponseDto,
  readonly [string, TenantsSummaryParams]
>;

const RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_GetKey = (getParams: TenantsSummaryParams) =>
  [RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_Path, getParams] as const;

export const RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_queryOptions = (
  getParams: TenantsSummaryParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get tenants leases and payments summary when listing is deactivated
 */
export const useRentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary = (
  getParams: TenantsSummaryParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary.getKey =
  RentalManagerUserPropertyDeactivateWebApiHandler_tenantsSummary_GetKey;
